export default Object.freeze({
  Unspecified: 0,
  ServiceAccount: 1,
  OAuthUser: 2,
});
